import { SelectOption } from '@components/common';

// error messages
export const ERROR_NAME = 'Name is required';
export const ERROR_ROLE = 'Role is required';
export const ERROR_JOB_TITLE = 'Job Title is required';

// integrations modal messages
export const INTEGRATION_MODAL_MSGS = {
  google: 'Are you sure?',
  microsoft: 'Are you sure?',
  zoom: 'Are you sure?',
  calendly: 'Are you sure?',
  salesforce: 'Are you sure?',
  slack: 'Are you sure?'
};

export const ROLE_OPTIONS: SelectOption<RoleCategory>[] = [
  { label: 'Research Operations', value: 'research_operations' },
  { label: 'Researcher', value: 'researcher' },
  { label: 'Designer', value: 'designer' },
  { label: 'Product Manager', value: 'product_manager' },
  { label: 'Marketer', value: 'marketer' },
  { label: 'Engineer', value: 'engineer' },
  { label: 'Other', value: 'other' }
];
